import { c as _c } from "react/compiler-runtime";
import { getCurrencyKey, readCurrencyFragment } from "@opensea/app-kit";
import { FlexColumn, List, TextBody, UnstyledButton, withSuspense } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { CurrencyBalanceItem } from "../../../flow/SideSheetFlows/ViewWalletFlow/tabs/CryptoTab/CurrencyBalanceItem";
import { useAccount } from "../../../polychain/hooks";
import { useBalances } from "../../../providers/BalancesProvider";
import { CurrencySkeletons } from "./CurrencySkeletons";
function OwnedCurrenciesComponent(t0) {
  const $ = _c(32);
  const {
    selectedChain,
    searchValue,
    onSelectCurrency,
    fetching
  } = t0;
  const t = useTranslations("wallet.OwnedCurrencies");
  const {
    address
  } = useAccount();
  const {
    balances,
    getBalanceOfCurrency
  } = useBalances();
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== address || $[1] !== balances || $[2] !== fetching || $[3] !== getBalanceOfCurrency || $[4] !== onSelectCurrency || $[5] !== searchValue || $[6] !== selectedChain || $[7] !== t) {
    let t6;
    if ($[15] !== searchValue || $[16] !== selectedChain) {
      t6 = balance => (selectedChain === "all" ? true : balance.currency.chainIdentifier === selectedChain) && (searchValue ? balance.currency.contractAddress.toLowerCase() === searchValue.toLowerCase() || balance.currency.name.toLowerCase().includes(searchValue.toLowerCase()) || balance.currency.symbol.toLowerCase().includes(searchValue.toLowerCase()) : true);
      $[15] = searchValue;
      $[16] = selectedChain;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    const ownedCurrencies = balances.filter(t6).map(_temp);
    T1 = FlexColumn;
    t4 = "gap-2.5";
    let t7;
    if ($[18] !== t) {
      t7 = t("yourTokens");
      $[18] = t;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    if ($[20] !== t7) {
      t5 = <TextBody>{t7}</TextBody>;
      $[20] = t7;
      $[21] = t5;
    } else {
      t5 = $[21];
    }
    T0 = List;
    t1 = "bg-transparent";
    t2 = false;
    t3 = fetching ? <CurrencySkeletons /> : ownedCurrencies.length === 0 ? <TextBody className="pb-5">{address ? t("noTokensFound") : t("connectToView")}</TextBody> : ownedCurrencies.map(currency => {
      const balance_1 = getBalanceOfCurrency(currency);
      return <UnstyledButton className="w-full pb-2" key={getCurrencyKey(currency)} onClick={() => onSelectCurrency(currency)}><CurrencyBalanceItem currency={currency} quantity={balance_1?.quantity ?? 0} usdValue={balance_1?.usdValue ?? 0} variant="24h" /></UnstyledButton>;
    });
    $[0] = address;
    $[1] = balances;
    $[2] = fetching;
    $[3] = getBalanceOfCurrency;
    $[4] = onSelectCurrency;
    $[5] = searchValue;
    $[6] = selectedChain;
    $[7] = t;
    $[8] = T0;
    $[9] = T1;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    T0 = $[8];
    T1 = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
  }
  let t6;
  if ($[22] !== T0 || $[23] !== t1 || $[24] !== t2 || $[25] !== t3) {
    t6 = <T0 className={t1} showBorder={t2}>{t3}</T0>;
    $[22] = T0;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== T1 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6) {
    t7 = <T1 className={t4}>{t5}{t6}</T1>;
    $[27] = T1;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
}
function _temp(balance_0) {
  return readCurrencyFragment(balance_0.currency);
}
function OwnedCurrenciesSkeleton() {
  const $ = _c(7);
  const t = useTranslations("wallet.OwnedCurrencies");
  let t0;
  if ($[0] !== t) {
    t0 = t("yourTokens");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <List className="bg-transparent" showBorder={false}><CurrencySkeletons count={2} /></List>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <FlexColumn className="gap-2.5">{t1}{t2}</FlexColumn>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export const OwnedCurrencies = withSuspense(OwnedCurrenciesComponent, <OwnedCurrenciesSkeleton />);